import { LocalDictionaryFactory } from '../../api/api.module'

import { IUserSession } from '../../../helpers/user-session'

import { LoggerService } from '../../common/common.module'

import { ReportDetailsDirectiveController, ReportDetailsScope } from './reports-details.directive.controller'

import { ReportHelper } from '../reports.helper'

//#region Asset Imports

import * as TEMPLATE from './reports-details.tpl.html'

//#endregion


// Setup

export class ReportDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$timeout', 'logger', 'localDictionary', 'userSession', (
        $scope: ReportDetailsScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: IUserSession
    ) => new ReportDetailsDirectiveController(
        $scope,
        $q,
        $timeout,
        logger,
        localDictionary,
        userSession,
        ReportHelper.REFERENCE_TYPE,
        ReportHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// Setup End